module.exports = __webpack_public_path__ + "media/react/mcat/pages/lesson_series/assets/biology-7b340283f5ccfd17e0d137590276caf4.svg";